
        import { createElement } from 'react';
        import { render } from 'react-dom';
        import 'wix/scripts/dashboard-asset/582e509c-5c2c-49f8-b5e7-c346d6c86056.js';

        async function main() {
          const getComponent = await window['__module_federation__containers']['bd59b79d-a12b-406d-914a-b85843e83362'].get('582e509c-5c2c-49f8-b5e7-c346d6c86056');
          render(createElement(getComponent().default), document.getElementById('root'));
        }

        main();
      